import styled from "styled-components";
import { CardContainer } from "@swiggy-private/dls-web-core/dist/components/CardContainer";
import { Image } from "@swiggy-private/dls-web-core/dist/components/Image";
import { FullWidthButton } from "@swiggy-private/dls-web-core/dist/components/FullWidthButton";
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";
import { getStealDealItemImageSize } from "./config";

export const ItemContainer = styled(CardContainer)(({ theme }) => {
    return {
        display: "flex",
        padding: "12px",
        alignItems: "center",
        borderRadius: theme.cornerRadius.small,
        borderColor: theme.colors[theme.colorMode].border_Tertiary,
        zIndex: 2,
        position: "relative",
        width: "70%",
        marginRight: theme.spacing.xSmall,
    };
});

export const ImageContainer = styled.div<{ isSnaccStorefrontV2?: boolean }>(
    ({ theme, isSnaccStorefrontV2 = false }) => {
        const { width, height } = getStealDealItemImageSize(isSnaccStorefrontV2);
        return {
            width: `${width}px`,
            height: `${height}px`,
            overflow: "hidden",
            borderRadius: theme.cornerRadius.xSmall,
        };
    },
);

export const StyledImage = styled(Image)<{ isSnaccStorefrontV2?: boolean }>(({ isSnaccStorefrontV2 = false }) => {
    return {
        ...(isSnaccStorefrontV2 && {
            transform: "scale(1.6)",
            "transform-origin": "center",
        }),
    };
});

export const ButtonContainer = styled.div(({ theme }) => {
    return {
        marginLeft: theme.spacing.xSmall,
        alignSelf: "flex-end",
    };
});

export const AddButton = styled(FullWidthButton)<{ isDisabled: boolean }>(({ theme, isDisabled }) => {
    return {
        borderRadius: theme.cornerRadius.xSmall,
        border: isDisabled
            ? `1px solid ${theme.colors[theme.colorMode].border_Subtle_Secondary}`
            : `1px solid ${theme.colors[theme.colorMode].border_Primary}`,
        boxShadow: isDisabled ? "none" : "2px 2px 0 0 #000",
        height: "32px",
        width: "64px",
    };
});

export const ItemDetailsContainer = styled.div(({ theme }) => {
    return {
        marginLeft: theme.spacing.xSmall,
        display: "flex",
        flexDirection: "column",
        width: "100vw",
        justifyContent: "space-between",
        alignSelf: "flex-start",
    };
});

export const BasePriceContainer = styled(Text)`
    text-decoration: line-through;
    text-decoration-line: line-through;
    margin-right: ${(props) => props.theme.spacing.xxxSmall};
`;

export const FlexContainer = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-top: 6px;
`;

export const PriceTag = styled.div(({ theme }) => {
    return {
        padding: `0 ${theme.spacing.xxSmall}`,
        marginLeft: theme.spacing.xxxSmall,
        backgroundColor: "#ffd501",
        transform: "skewX(-8deg)",
        boxShadow: "rgb(0, 0, 0) 1px 1px 0px 0px",
    };
});

export const Price = styled(Text)`
    transform: skewX(8deg);
`;
